module.exports = __webpack_public_path__ + "6c988de1ca880c6f991257cea888c915.svg";